import { IFilterItemCollection } from '@solar/solar/dashboard/db-filter/filter';
import { IDB_filter } from 'solar-bo';
import { SupervisionErrorStatusEnum } from 'solar-bo';


export class SupervisionFilter {
  /**
* filters selected to show issues in lists and maps
*/
  filterSelected: IFilterItemCollection[]=[];
  /**
   * used only by verificator profile when user is validating supervision
   */
  filter_status: SupervisionErrorStatusEnum;

  filter_status_type:SupervisionErrorStatusEnum=SupervisionErrorStatusEnum.noerror;

  show_issueRepeated:boolean=true;

  addFilter(newfilter: IFilterItemCollection){
    let filterIndex=this.filterSelected.findIndex(item=>item.id_filter=== newfilter.id_filter);
    if (filterIndex==-1){
      this.filterSelected.push(newfilter);
    }
    else{
      this.filterSelected[filterIndex].value=newfilter.value;
    }
  }

  addFilters(newfilter: IFilterItemCollection[]){
    for(let filter of newfilter){
      this.addFilter(filter);
    }
  }

  removeFilter(filterToRemoveKey: string){
    let filterIndex=this.filterSelected.findIndex(item=>item.id_filter=== filterToRemoveKey);
    if (filterIndex==-1){
      this.filterSelected.splice(filterIndex,1);
    }
  }
  
}